var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.styleClass.frameWrapper},[_c('div',{ref:"frame",class:_vm.styleClass.avatarFrame},[_c('img',{ref:"preview",class:_vm.styleClass.avatarImage,attrs:{"src":_vm.src}})])])}
var staticRenderFns = []

export { render, staticRenderFns }